import React, { forwardRef } from 'react';
import type { GatsbyLinkProps } from 'gatsby';
import type { ButtonProps as ChakraButtonProps } from '@chakra-ui/react';
import { Button } from '@chakra-ui/react';
import CanonicalLink from '../CanonicalLink';

const ButtonLink = forwardRef<
    HTMLAnchorElement,
    | GatsbyLinkProps<{}>
    | (Omit<ChakraButtonProps, 'type'> & {
          to: string;
      })
>(({ to, ...props }, ref) => (
    // @ts-ignore
    <Button
        ref={ref}
        as={CanonicalLink}
        to={to}
        textDecoration="none"
        textTransform="lowercase"
        whiteSpace="normal"
        height="auto"
        px={2}
        py={2}
        sx={{
            // do these via sx to avoid nuking the defaut Button :hover styles
            '&:hover': {
                textDecoration: 'none',
            },
        }}
        {...props}
    />
));

export default ButtonLink;
